import { render, staticRenderFns } from "./quiz-format.html?vue&type=template&id=8beefe02&scoped=true&"
import script from "./quiz-format.js?vue&type=script&lang=js&"
export * from "./quiz-format.js?vue&type=script&lang=js&"
import style0 from "./quiz-format.css?vue&type=style&index=0&id=8beefe02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8beefe02",
  null
  
)

export default component.exports